export default "__VITE_ASSET__067df020__"